module.exports = {
    controller:require('apps/login/modules/esqueci-password/controller-esqueci-password'),
    view      :require('apps/login/modules/esqueci-password/view-esqueci-password')
};